import React from "react"
import { styled } from "../../../stitches.config";
import ReactCompareImage from 'react-compare-image';

import { withDrawingBoard } from "../../HOCs/withDrawingBoard"

const transformUrl = (url, format = "webp") => {
    if (!url) return "";
    const width = window.innerWidth < 996 ? 960 : 1400;

    const newUrl = url.replace(
        /(\d+,\d+,\d+,\d+)\.(jpg|jpeg|png|webp)$/i,
        `${width},0,0,0.${format}`
    );

    return newUrl === url ? url : newUrl;
};


const ImageCompare = ({ blockData, ...props }) => {
    const { url1 = "", url2 = "" } = blockData;

    const leftUrl = transformUrl(url1);
    const rightUrl = transformUrl(url2);

    return <Wrap>
        <ReactCompareImage leftImage={leftUrl} rightImage={rightUrl} skeleton={() => { console.log(props) }} />
    </Wrap>
}

const Wrap = styled("div", {
    margin: "25px auto",
    "@media (min-width: 992px)": {
        maxWidth: "700px",
        margin: "35px auto"
    }
})

export default withDrawingBoard(props => props.blockData.hasCanvas)(ImageCompare)